import { useMutation } from '@tanstack/react-query';
import { getExerciseAnswer } from '../../queries/DailySchedule/scheduleContent';

export function useGetExerciseAnswer() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (params: { cronogramaId: string; exerciseId: string }) =>
      getExerciseAnswer(params.cronogramaId, params.exerciseId),
  });

  return { mutateAsync, isLoading: isPending };
}
